'use strict';

/*====================================================
ACCORDION
====================================================*/
const slideUp = (el, displayStyle = 'none', duration = 300) => {
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight; // 強制リフロー
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.transitionTimingFunction = 'ease';
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = displayStyle;
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-timing-function');
    el.classList.remove('is-open');
  }, duration);
};

const slideDown = (el, displayStyle = 'block', duration = 300) => {
  el.classList.add('is-open');
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;
  if (display === 'none') {
    display = displayStyle; // 新しい display スタイルを適用
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight; // 強制リフロー
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.transitionTimingFunction = 'ease';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  setTimeout(() => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-timing-function');
  }, duration);
};

const slideToggle = (el, displayStyle = 'block', duration = 300) => {
  if (window.getComputedStyle(el).display === 'none') {
    return slideDown(el, displayStyle, duration);
  } else {
    return slideUp(el, 'none', duration);
  }
};

{
  /*====================================================
  スピードまで指定できるバージョン（.headerの高さ分手前で止まる）
  ====================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    function smoothScroll(target, duration) {
      const header = document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 0;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }

      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    }

    // 現在のbottom値を取得する関数
    function getDefaultBottomPosition() {
      if (window.innerWidth <= 767) {
        return `${6}vw`; // スマホ表示時は6vw
      }
      return '4rem'; // PC表示時は4rem
    }

    // vwをピクセルに変換する関数
    function vwToPixels(vw) {
      return (window.innerWidth * vw) / 100;
    }

    // 最上部に戻るボタンの要素を作成
    const gotopButton = document.createElement('a');
    gotopButton.href = '#';
    gotopButton.className = 'gotop';

    const srSpan = document.createElement('span');
    srSpan.className = 'sr-only';
    srSpan.textContent = '最上部に戻る';

    gotopButton.appendChild(srSpan);

    // スクロール監視の関数
    function checkScroll() {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const scrollThreshold = 10 * rootFontSize;
      const footer = document.querySelector('#footer');
      const gotopHeight = gotopButton.offsetHeight;

      // ボタンの表示/非表示の制御
      if (window.scrollY > scrollThreshold) {
        gotopButton.classList.add('is-active');
      } else {
        gotopButton.classList.remove('is-active');
      }

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const defaultBottom = window.innerWidth <= 767 ? (window.innerWidth * 6) / 100 : rootFontSize * 4;

        // フッターが視界に入ってきた時
        if (footerRect.top < windowHeight) {
          // ボタンの半分がフッターにかかる位置を計算
          const stopPosition = windowHeight - defaultBottom - gotopHeight / 2;

          // フッターの位置がストップ位置より上にある場合
          if (footerRect.top < stopPosition) {
            const adjustedBottom = windowHeight - footerRect.top - gotopHeight / 2;
            gotopButton.style.bottom = `${adjustedBottom}px`;
          } else {
            // デフォルトの位置を維持
            gotopButton.style.bottom = window.innerWidth <= 767 ? '6vw' : '4rem';
          }
        } else {
          // デフォルトの位置に戻す
          gotopButton.style.bottom = window.innerWidth <= 767 ? '6vw' : '4rem';
        }
      }
    }

    // スクロールとリサイズのイベントリスナーを追加
    window.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    checkScroll();

    // 他のページからのハッシュリンクの初期位置調整
    const hash = window.location.hash;
    if (hash) {
      const header = document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 0;
      setTimeout(() => {
        window.scrollBy(0, -headerHeight);
      }, 100);
    }

    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', checkScroll);
    // リサイズ時にも位置を再計算
    window.addEventListener('resize', () => {
      gotopButton.style.bottom = getDefaultBottomPosition();
      checkScroll();
    });
    checkScroll();

    // gotopボタンのイベントリスナー
    gotopButton.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector('html');
      smoothScroll(target, 500);
    });

    // body要素の末尾に追加
    document.body.appendChild(gotopButton);

    // 通常のアンカーリンクのイベントリスナー
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      if (!anchor.classList.contains('gotop')) {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const speed = 500;
          const href = this.getAttribute('href');
          const target = document.querySelector(href === '#' || href === '' ? 'html' : href);
          if (target) {
            smoothScroll(target, speed);
          }
        });
      }
    });
  });
}
